<template>
	<div class="cookie_law" v-show="!isAccepted && copy">
		<div class="cookie_law__inner">
			<div class="cookie_law__icon">
			<svg width="40px" height="40px" viewBox="0 0 40 40">
					<g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<g id="procore_elements" transform="translate(-708.000000, -441.000000)" fill="#FF3D37" fill-rule="nonzero">
									<path d="M727.741032,441 L728.692122,441.007272 C729.431003,441.036054 730.006569,441.656245 729.977685,442.392509 C729.973148,442.508175 729.953523,442.622761 729.919305,442.73338 C729.639786,443.637001 729.500027,444.391866 729.500027,444.997976 C729.500027,446.568235 726.072738,451.130311 727.741032,452.933126 C728.326566,453.565874 729.952164,454.134081 731.630496,454.698967 L732.302301,454.92489 C734.088798,455.527652 735.785512,456.135923 736.194188,456.824004 C737.461325,458.957461 738.61291,468.124115 743.450354,470.504735 L743.883458,470.711612 C744.553878,471.022375 744.844543,471.815855 744.532676,472.4839 C744.496536,472.561314 744.453022,472.635093 744.402731,472.70422 L744.162315,473.031257 L743.709607,473.626087 C743.347975,474.088866 743.025404,474.469361 742.741895,474.767573 C739.081982,478.617282 733.588719,481 727.846923,481 C723.231758,481 718.948062,480.347804 715.44229,477.739971 C710.522927,474.080613 705.532448,462.567662 709.351192,454.351483 C711.5872,449.540625 717.714587,444.310284 719.773058,443.566163 C722.453347,442.59726 724.866999,441.058777 727.741032,441 Z M745.12154,458.340163 C746.600373,458.340163 748,459.837105 748,462.302207 C748,463.972115 746.811547,464.297881 745.585085,464.334286 L745.234627,464.337724 L744.718105,464.325314 L744.230469,464.308224 L743.931364,464.303341 C742.452531,464.303341 741.549516,463.108757 741.549516,461.635162 C741.549516,460.161568 743.642707,458.340163 745.12154,458.340163 Z M738.418365,444.999267 C739.339184,444.999267 740.210684,445.9982 740.210684,447.643202 C740.210684,448.757558 739.470675,448.974948 738.706999,448.999241 L738.48878,449.001536 L738.16716,448.993254 L737.863525,448.981849 L737.677283,448.978591 C736.756464,448.978591 736.194188,448.181426 736.194188,447.198073 C736.194188,446.214719 737.497546,444.999267 738.418365,444.999267 Z" id="Combined-Shape"></path>
							</g>
					</g>
			</svg>
			</div>
			<div class="cookie_law__copy" v-html="copy"></div>
			<button type="button" @click="() => this.$emit('accept')">{{button}}</button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { getCookie, setCookie } from 'tiny-cookie'

export default {
	data() {
		return {
			cookieName: 'procore_law_accept',
			isAccepted: false,
		}
	},
	computed: {
    ...mapState({
			cookie: (state) => state.site.cookie,
			currentLanguage: (state) => state.site.currentLanguage,
		}),
		translatedCookie() {
      return this.cookie[this.currentLanguage];
		},
		copy() {
			return this.translatedCookie?.copy
		},
		button() {
			return this.translatedCookie?.title
		}
	},
	created() {
		this.$on('accept', this.onAccept);
	},
	mounted() {
		const accept = getCookie(this.cookieName) === 'true';
		console.log('accept', accept);
		if (accept) {
			console.log('cooki is not set to yes')
			this.isAccepted = true;
		}
	},
	methods: {
		onAccept() {
			console.log('onAccepte action');
			this.isAccepted = true
		}
	},
	watch: {
		isAccepted(newValue) {
			console.log('newValue', newValue);
			setCookie(this.cookieName, newValue, { expires: '1Y' });
		}
	}

}
</script>

<style lang="scss" scoped>
@keyframes border1 {
	0% {
		// border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;

	}

	25% {
		// border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
		border-radius: 80% 50% 88% 90% / 90% 90% 85% 80%;

	}

	50% {
		// border-radius: 50% 60% 65% 60% / 50% 60% 65% 70%;
		border-radius: 50% 60% 65% 60% / 50% 60% 65% 70%;

	}


	75% {
		// border-radius: 100% 60% 60% 65% / 95% 60% 80% 64%;
		border-radius: 100% 60% 60% 65% / 95% 75% 80% 64%;

	}

	100% {
		// border-radius: 60% 100% 70% 60% / 80% 70% 80% 60%;
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}
}

.cookie_law {
	display: block;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 20px 20px 0 20px;
	background: $colorMint;
	z-index: 4;



	&__inner {
		@include gridContainer();
		align-items: center;
		justify-content: center;
		width: 100%;

		@include mq($from: m) {
			flex-wrap: nowrap
		}
	}

	&__icon {
		margin-bottom: 20px;
	}

	&__copy {
		@include fontCopy;
		font-size: 14px !important;
		margin-bottom: 20px;
		// flex: 1 1 calc(100% - 180px);
		padding-left: 20px;

		&::v-deep p {
			font-family: inherit;
			font-size: inherit;
			line-height: inherit;
		}

		@include mq($to: m) {
			flex: 1 1 calc(100% - 40px);
		}


		@include mq($from: m) {
			padding-right: 50px;
		}
	}

	button {
		@include fontCopy;
		font-size: 12px !important;
		font-weight: 500;
		letter-spacing: 1px;;
		text-transform: uppercase;
		border: 2px solid $colorRed1;
		background: transparent;
		border-radius: 62% 60% 55% 65% / 85% 72% 65% 55%;
		transition: background-color .3s;
		cursor: pointer;

		padding: 10px 20px;
		animation: border1 4s infinite linear;
		flex: 0 1;
		margin-bottom: 20px;

		&:hover {
			background: $colorRed1;
			// border-radius: 0;
			// animation: none;
		}

	}
}

</style>